import React from 'react';
import { useStore } from '../context/Store';
import Button from '../components/ui/Button';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { Link } from 'react-router-dom';

const { FiCheck, FiZap, FiShield, FiClock } = FiIcons;

const Pricing = () => {
  const { user, upgradePlan } = useStore();

  const handleUpgrade = () => {
    upgradePlan();
    alert("Lifetime Access Activated! (Mock)");
  };

  return (
    <div className="py-24 px-4 bg-gray-50 min-h-screen">
      <div className="text-center max-w-3xl mx-auto mb-20">
        <h1 className="text-5xl sm:text-6xl font-black text-gray-900 mb-6 tracking-tight">One simple price.</h1>
        <p className="text-xl text-gray-600 font-medium leading-relaxed">
          Stop paying monthly subscriptions for domain parking. 
          Pay once, own the tool forever.
        </p>
      </div>

      <div className="max-w-xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white p-12 rounded-[3rem] border-4 border-indigo-600 shadow-2xl relative overflow-hidden"
        >
          <div className="absolute top-8 right-[-40px] bg-red-500 text-white text-xs font-black px-12 py-2 rotate-45 shadow-lg">
            75% OFF
          </div>
          
          <div className="mb-10 text-center">
            <h3 className="text-3xl font-black text-gray-900 mb-4">Lifetime Access</h3>
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-7xl font-black text-gray-900">$29</span>
              <span className="text-gray-400 line-through text-2xl font-bold">$199</span>
            </div>
            <p className="text-gray-500 font-bold mt-4 uppercase tracking-widest text-sm">One-time payment</p>
          </div>

          <ul className="space-y-5 mb-12">
            {[
              "Unlimited Domain Pages",
              "AI Description Engine",
              "Direct WhatsApp Link",
              "Buyer Contact Forms",
              "High-Converting Templates",
              "Zero Commission Fees",
              "Priority Support"
            ].map((item) => (
              <li key={item} className="flex items-center gap-4 text-gray-700 font-bold text-lg">
                <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center text-green-600 shrink-0">
                  <SafeIcon icon={FiCheck} className="w-4 h-4" />
                </div>
                {item}
              </li>
            ))}
          </ul>

          {user?.plan === 'pro' ? (
            <Button className="w-full h-16 text-xl rounded-2xl" variant="outline" disabled>
              Lifetime Access Active
            </Button>
          ) : user ? (
            <Button onClick={handleUpgrade} className="w-full h-16 text-xl font-black shadow-2xl shadow-indigo-100 rounded-2xl">
              Get Lifetime Access Now
            </Button>
          ) : (
            <Link to="/signup">
              <Button className="w-full h-16 text-xl font-black shadow-2xl shadow-indigo-100 rounded-2xl">
                Claim Offer Now
              </Button>
            </Link>
          )}

          <p className="text-center mt-6 text-red-500 font-bold text-sm flex items-center justify-center gap-2">
            <SafeIcon icon={FiZap} className="w-4 h-4" />
            Limited to the first 100 users only
          </p>

          <div className="mt-12 pt-12 border-t border-gray-100 grid grid-cols-2 gap-8">
            <div className="text-center">
              <SafeIcon icon={FiShield} className="mx-auto text-indigo-600 mb-3 w-6 h-6" />
              <p className="text-[11px] text-gray-400 font-black uppercase tracking-widest">Secure Payment</p>
            </div>
            <div className="text-center">
              <SafeIcon icon={FiClock} className="mx-auto text-indigo-600 mb-3 w-6 h-6" />
              <p className="text-[11px] text-gray-400 font-black uppercase tracking-widest">Instant Setup</p>
            </div>
          </div>
        </motion.div>
        
        <p className="text-center mt-10 text-gray-500 font-medium">
          30-day money-back guarantee. No questions asked.
        </p>
      </div>
    </div>
  );
};

export default Pricing;